<template>
    <div class="viewing-discipline-video">
        <h4 class="page-title">Видео</h4>
        <el-button 
            @click="addVideo()"
            class="viewing-discipline-vebinars__add-button" 
            icon="el-icon-circle-plus-outline" 
            type="success" 
            plain>Добавить видео</el-button>
        <el-table
            v-if="!mobileMode"
            :data="videoList"
            style="width: auto">
        <el-table-column
            label="Название"
            class-name="table-row"
            width="auto">
            <template slot-scope="scope">
                <a 
                    class="video-link"
                    :href="scope.row.url" 
                    target="blank">
                    {{scope.row.name}}</a>
            </template>
        </el-table-column>
        <el-table-column
            width="100px"
            align="center">
            <template slot-scope="scope">
                <button class="table-remove-btn" @click="editVideo(scope.row)"><i class="el-icon-edit"></i></button>
            </template>
        </el-table-column>
        <el-table-column
            width="100px"
            align="center">
            <template slot-scope="scope">
                <button class="table-remove-btn" @click="removeVideo(scope.row)"><i class="fas fa-trash-alt"></i></button>
            </template>
        </el-table-column>
        </el-table>
        <el-collapse v-if="mobileMode && videoList.length" v-model="activeName" accordion>
            <el-collapse-item   v-for="(video, index) of videoList" :key="index" :title="video.name" :name="index+1">
                <div class="content-wrp">
                    <button class="table-remove-btn" @click="editVideo(video)"><i class="el-icon-edit"></i></button>
                    <button class="table-remove-btn" @click="removeVideo(video)"><i class="fas fa-trash-alt"></i></button>
                </div>
            </el-collapse-item>
        </el-collapse>
        <p v-if="mobileMode && !videoList.length">Нет видео</p>
    </div>
</template>

<script>
import {mapMutations} from 'vuex'
export default {
    name: 'viewingVideo',
    data() {
        return {
            activeName: 0
        }
    },
    computed:{
        videoList(){
            return this.$store.state.viewingDiscipline.treeData.videos
        },
        mobileMode(){
            return this.$store.state.mobileMode
        }
    },
    methods: {
        ...mapMutations(['setModalData', 'setSelectedItem', 'updateVideoTree']),
        addVideo(){
            let obj = {
                name: 'actionVideo',
                data: null,
                title: 'Видео',
                formName: 'templateVideoForm'
            }
            this.setModalData(obj)
        },
        removeVideo(data){
            let id = data.id
          this.axios.delete(`api/disciplines/${this.$route.params.did}/videos/${data.id}`)
            .then(res=>{
                if(res.data.status){
                    this.updateVideoTree(res.data.videoMap)
                }
                this.notify(res.data.status, res.data.message)
            })
        },
        editVideo(value){
            let obj = {
                name: 'actionVideo',
                data: value,
                title: 'Видео'
            }
            this.setModalData(obj)
        },
        showVideo(value){
            let obj = {
                name: 'showVideo',
                data: value.url
            }
            this.setModalData(obj)
        },
        notify(status, text){
            const h = this.$createElement
            this.$notify({
                title: '',
                message: h('i', { style: `color: ${status ?  '#67C23A' : ' #f56c6c' }` }, text)
            });
        }
    },
    mounted() {
    
    },
}
</script>

<style lang="scss">
    .viewing-discipline-video{
        overflow-y: auto;
        .el-table td{
            padding: 0;
        }
        .cell{
            height: 100%;
            width: 100%;
        }
        .video-link{
            display: block;
            height: 100%;
            width: 100%;
            padding: 10px;
        }
        .table-remove-btn{
            transition-property: color;
            transition-duration: 0.3s;
            cursor: pointer;
            background-color: transparent;
            padding: 5px;
            border: none;
            color: $secondary-text-clr;
            &:hover{
                color: $brand-clr-1;
            }
        }
        .content-wrp{
            text-align: center;
            font-size: 20px;
            button{
                width: 35px;
                height: 35px;
                margin: 0 10px;
                padding: 0;
                font-size: 25px;
                i{
                    font-size: inherit;
                }
            }
        }
    }
    @media (max-width: 400px){
        .viewing-discipline-video{
            .viewing-discipline-vebinars__add-button{
                margin-bottom: 20px;
            }
        }
    }
</style>